module.exports = __webpack_public_path__ + "media/images/hold-icon-bcfe607388b6707ddd33bfbfe82ca0356e0e8293bfef0a398e06d21ee1d96164.svg";